import React, {RefObject} from 'react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {observer} from 'mobx-react';
import {TopBannerBox} from "./boxes/top-banner/top-banner.box";
import {TopBannerImageBox} from "./boxes/top-banner-image/top-banner-image.box";
import {TopBannerLogoImageBox} from "./boxes/top-banner-logo-image/top-banner-logo-image.box";
import {TopBannerTitleBox} from "./boxes/top-banner-title/top-banner-title.box";
import {TopBannerLiveLogoBox} from "./boxes/top-banner-live-logo/top-banner-live-logo.box";
import {ThemeProvider} from "styled-components";
import {AnimatedTopImageComponent} from '../animated-top-image/animated-top-image.component';
import {AnimatedTopImageConfiguration, CmsBannerIds} from '../../services/configurations/config-data-sections/arenas.configuration';
import {BannerComponent} from '../banner/banner.component';
import {CyClass} from '../../../common/cy-classes';

export interface TopImageComponentProps {
    image: string;
    animatedBanner?: AnimatedTopImageConfiguration;
    title?: string;
    altText?: string;
    className?: string;
    topImageRef?: RefObject<HTMLDivElement>;
    CMSbanner?: CmsBannerIds;
}

export const TopImageComponent = observer(class TopImageComponent extends OrbitComponent<TopImageComponentProps> {

    private _renderLogoAndTitle() {
        if (this.props.title) {
            const srcLogo = this.services.device.isMobile
                ? this.services.theme.currentTheme.assets.images.casino_live_logo_mobile_png.toString()
                : this.services.theme.currentTheme.assets.images.casino_live_logo_png.toString();
            return (
                <TopBannerLiveLogoBox>
                    <TopBannerLogoImageBox
                        className={'cy-top-banner-logo-image'}
                        alt={this.services.translation.translate(this.props.title) + " Logo"}
                        src={srcLogo}
                    />
                    <TopBannerTitleBox className={'cy-top-banner-title'}>{this.services.translation.translate(this.props.title)}</TopBannerTitleBox>
                </TopBannerLiveLogoBox>
            )
        }
        return null;
    }

    private _renderCMSbanner() {
        const arenaName = this.services.arenas.getCurrentArena().arenaName;
        this.services.analytics.sendOrbitUserFlowEvent('ArenaAtmosphericImage', 'Banner_Show', arenaName);

        return (<BannerComponent
            templateID={this.props.CMSbanner?.templateID}
            componentID={this.props.CMSbanner?.componentID}
            contentID={this.props.CMSbanner?.contentID}
            bannerAdminPlaceholderId={this.props.CMSbanner?.bannerAdminPlaceholderId}
            showPlaceholder={true}
        />);
    }

    render() {
        if (this.props.CMSbanner
            && this.services.abTestingFeatureDataProvider.arenaBannerTest.isEnabled
            && !this.services.miniOrbit.isEnabled) {
            return (
                this._renderCMSbanner()
            )
        }

        if (!this.props.image || (this.services.gamesFilter.isFilterOn && this.services.mediaQuery.sAndBelow)) {
            return null;
        }

        // TODO: maybe get also an image placeholder to enable lazy loading
        return (
            <ThemeProvider theme={this.services.theme.currentTheme}>
                <TopBannerBox ref={this.props.topImageRef} className={CyClass('cy-top-banner')}>
                    {this.props.animatedBanner ?
                        <AnimatedTopImageComponent imageAnimationConfig={this.props.animatedBanner} />
                        :
                        <TopBannerImageBox
                            alt={this.services.translation.translate(this.props.title || this.props.altText || "")}
                            src={this.props.image}
                            className={'cy-top-banner-image'}
                            fetchPriority="high"
                        />}
                    {this._renderLogoAndTitle()}
                </TopBannerBox>
            </ThemeProvider>
        )

    }
});
